import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ClientPortal from "@/pages/ClientPortal";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="bg-[#050505] text-white min-h-screen">
          <div className="grain" aria-hidden="true" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/avis" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/client/:id" element={<ClientPortal />} />
            <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster position="top-center" theme="dark" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
